import { apiService } from "api/apiService";
import { useNotifyStore } from "store/modules/notifyStore";
import { readonly, ref } from "vue";

export interface KnowledgeBaseModuleOption {
  id: number;
  label: string;
}

interface ModuleEnumResponse {
  id: number;
  name: string;
}

const options = ref<KnowledgeBaseModuleOption[]>([]);
const loading = ref(false);
const error = ref<string | null>(null);
let inflight: Promise<KnowledgeBaseModuleOption[]> | null = null;

const fetchModuleOptions = async (): Promise<KnowledgeBaseModuleOption[]> => {
  if (options.value.length > 0) {
    return options.value;
  }
  if (inflight) {
    return inflight;
  }
  loading.value = true;
  error.value = null;
  inflight = apiService
    .get<{ data: ModuleEnumResponse[] }>("/api/global/enum/module")
    .then(({ data: { data } }) => {
      const mapped = data.map((module) => ({
        id: module.id,
        label: module.name,
      }));
      options.value = mapped;
      return mapped;
    })
    .catch((e: unknown) => {
      error.value = "Kon modules niet laden";
      useNotifyStore().setNotifyError({
        error: e as object,
        fallbackMessage: error.value,
      });
      throw e;
    })
    .finally(() => {
      loading.value = false;
      inflight = null;
    });
  return inflight;
};

export const useKnowledgeBaseModuleOptions = () => ({
  moduleOptions: readonly(options),
  loading: readonly(loading),
  error: readonly(error),
  fetchModuleOptions,
});
